<template>
	<div class="pdf-wrapper" align=center v-if="this.horoscope.criteria.criteriaId">

		<div id="basicNatalChartReportHeader" style="width: 90%; padding-top: 10px; padding-bottom: 10px; display: inline-block;">
		</div>

		<div class="pdf-loading-area" id="basicNatalChartReportHeader" style="display: flex; align-items: center; justify-content: space-between; gap: 10px; flex-wrap: wrap;">

			<button @click="scrollIframeToTop">
				Scroll To Top
			</button>

			<h1 style="margin: 0; color: #087F8C; font-size: 1.5rem; text-align: center;">
				Free Birth Chart Interpretation
			</h1>

			<button @click="scrollIframeToBottom">
				Scroll To Bottom
			</button>

		</div>

		<div style="resize: vertical;
					overflow: hidden;
					max-width: 900px;
					min-height: 500px;
					border: 1px solid transparent;
					border-radius: 5px;
					background-origin: border-box;
					background-clip: content-box, border-box;
					box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
					padding-top: 20px;
					padding-bottom: 20px;
					margin-top: 20px;" >
					
			<iframe ref="myIframe"
				:src="htmlUrl"
				style="width: 100%; height: 100%; max-width: 900px; min-height: 500px; border: none; border-radius: 5px;">
			</iframe>
		</div>

			<button @click="downloadFreeBirthChartInterepreation()" style="margin-top: 25px;">
				Download Free Report
			</button>

<!--
		<div class="pdf-area" v-show="!pdfLoading">
			<iframe ref="myIframe" :src="htmlUrl" width="100%" height="450" style="border: none;" v-on:load="pdfLoaded()">
				This browser failed to display your astrology report. Please download the report as HTML file to view it: 
					<a
					:href="htmlUrl"
					v-text="'Download Report File'"
					@click.prevent="downloadFreeBirthChartInterepreation()" />
			</iframe>
		</div>
-->		
	</div>
</template>

<script>
import HTTP from '@/http-axios';
import ApiBaseUrl from '@/http-api-base-url'
import { queryString, generatePaidNatalChartKey } from '@/util.js'

export default {
	props: {
		horoscope: {
			type: String
		}
	},
	data() {
		return {
			htmlUrl: "",
			pdfLoading: false,
		}
	},
	created() {
		this.htmlUrl =  ApiBaseUrl() + '/api/html/basic/report/view?fileCriteriaId=' + this.horoscope.criteria.criteriaId + '&' + this.queryString(this.horoscope.criteria)
	},
	mounted() {
	},
	methods: {
		ApiBaseUrl: function() {
			return ApiBaseUrl();
		},
        queryString: function (obj) {
            return queryString(obj);
        },
        getCriteriaToken: function() {
            return generatePaidNatalChartKey(this.criteria);
        },
		scrollIframeToTop() {
			const iframe = this.$refs.myIframe;
			if (iframe && iframe.contentWindow) {
				iframe.contentWindow.scrollTo(0, 0);
			}
    	} ,
		scrollIframeToBottom() {
			const iframe = this.$refs.myIframe;
			if (iframe && iframe.contentWindow && iframe.contentWindow.document) {
				const scrollHeight = iframe.contentWindow.document.body.scrollHeight;
				iframe.contentWindow.scrollTo(0, scrollHeight);
			}
		},
		downloadFreeBirthChartInterepreation() {
			HTTP().get(ApiBaseUrl() + '/api/html/basic/report/download?fileCriteriaId=' + this.horoscope.criteria.criteriaId + '&' + this.queryString(this.horoscope.criteria), { responseType: 'text' })  // text/html response
			.then(response => {
				const blob = new Blob([response.data], { type: 'text/html' })
				const link = document.createElement('a')
				link.href = URL.createObjectURL(blob)
				link.download = "VAC-Foundational-Astrology-Report.html"
				link.click()
				URL.revokeObjectURL(link.href)
			})
			.catch(console.error)
		},
		pdfLoaded() {
			this.pdfLoading = false;
		},
	}
}
</script>

<style scoped>

.pdf-wrapper {
  border: 0px solid;
  min-width: 800px;
  width: 95%;
  height: 95%;
  padding-top: 35px;
  padding-left: 20px;
  margin: auto;
}

.pdf-loading-area {
	border: 0px solid;
	border-radius: 0px;
	width:100%;
	max-width: 900px;
	height:100%;
}

.pdf-area {
	border: 1px solid ;
	border-radius: 5px;
	width:100%;
	max-width: 900px;
	height:100%;
	min-height: 450px;
}

.screen-centered-img {
    position:absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    margin:auto;
}
button {
  background-color: #087F8C;
  color: #FFFFFF;
  font-weight: bold;
  border: none;
  padding: 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  cursor: pointer;
  border-radius: 10px;
  outline: none;
  text-align: center;
}


</style>
